  <!-- src/components/index.vue -->

<template>
  <section>
    <div v-if="years.length > 0">
      <ul class="d-flex justify-content-center flex-wrap align-items-center">
        <li v-for="year in years" :key="year" class="subTitleFont m-2">
          <h6 :class="{ 'textmaintoggle': activeYear === year }" class="textmainhover" @click="toggleYear(year)">
           {{ formatYear(year) }}
          </h6>
        </li>
      </ul>
      <!-- Loading GIF while images are preloading -->
      <ArtGalleryLoop v-if="activeYear && !loading" :artPosts="artPosts" :year="activeYear" :category="'Digital Art'" :componentType="'ArtGalleryLoopPart1Image'" :userId="userId" :userSettings="userSettings" :usageType="'profilePage'"/>
    </div>
    <div v-else-if="isPrivate" class="text-center p-4">
        <p>This section is private</p>
    </div>
    <!-- Show message if no art posts found (but not private) -->
    <div v-else-if="!isPrivate && !loading" class="text-center p-4">
      <p>This section is Empty</p>
    </div>
    <div v-if="loading" class="text-center p-4 loading-container textmain align-items-center d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </section>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.min.css';
  import ArtGalleryLoop from '@/ArtGalleryLoop.vue';
  import AOS from 'aos';
  import 'aos/dist/aos.css'; // Import AOS styles
  export default {
    name: 'App',
    props: ['userId', 'userSettings'], // Accept userId and userSettings props
    components: {
    ArtGalleryLoop,
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        years: [],
        activeYear: null,
        yearsByCategory: [],
        artPosts: [],
        isPrivate: false, // Track if gallery is private
        loading: true, // Add loading state
        hoverText: 'Hover over an icon to see my what it is.',
      };
    },
    methods: {
      formatYear(year) {
        return year === 2016 ? 'Archive' : year;
      },
      toggleYear(property) {
        //console.log('Toggling', property);
        
        // Clear current images first
        this.loading = true;
        this.activeYear = null;
        
        // Small delay to allow DOM to clear, then set new year
        this.$nextTick(() => {
          this.activeYear = property;
          
          // Get images for the selected year and preload them
          const yearImages = this.artPosts.filter(post => post.year === property);
          this.preloadImages(yearImages);
        });
      },
      preloadImages(artPosts) {
        const imageUrls = artPosts.map(post => post.image_url).filter(url => url);
        const imagePromises = imageUrls.map(url => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to not block other images
            img.src = url;
          });
        });
        
        Promise.all(imagePromises).then(() => {
          this.loading = false; // Set loading to false when all images are preloaded
          // Refresh AOS after images are loaded
          this.$nextTick(() => {
            AOS.refresh();
          });
        });
      },
    },
    mounted(){
      
      AOS.init();
    },
    created() {
    // Only fetch if userId is provided
    if (!this.userId) {
      console.warn('No userId provided to ArtSection');
      return;
    }

    let apiUrl;
    if (process.env.NODE_ENV === 'production') {
      apiUrl = `/api/artPosts/user/${this.userId}`;
    } else {
      apiUrl = `http://localhost:3002/api/artPosts/user/${this.userId}`;
    }
    
    fetch(apiUrl)
      .then(response => {
        if (response.status === 403) {
          // Gallery is private
          this.isPrivate = true;
          throw new Error('Gallery is private');
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched data:', data);
        this.artPosts = data; // Store the fetched data
        
        // Get all unique years from all categories
        const allYears = data.map(item => item.year);
        this.years = [...new Set(allYears)].sort((a, b) => b - a); // Sort years descending
        
        // Create yearsByCategory object for all categories
        const categories = [...new Set(data.map(item => item.category))];
        this.yearsByCategory = categories.reduce((acc, category) => {
          const years = data
            .filter(item => item.category === category)
            .map(item => item.year);
          acc[category] = [...new Set(years)].sort((a, b) => b - a); // Sort years descending
          return acc;
        }, {});
        
        // Preload all images before setting loading to false
        this.preloadImages(data);
      })
      .catch(error => {
        console.error('Error fetching art posts:', error);
        this.loading = false; // Set loading to false even on error
        if (error.message !== 'Gallery is private') {
          // Only log non-privacy errors
          console.error('Unexpected error:', error);
        }
      });
    },
  }
</script>

<style scoped>

</style>
